import { UserRole } from '@prisma/client'

type AccessControlProps = {
  role: UserRole | undefined
  renderIfAdmin: React.ReactNode
  renderIfUser: React.ReactNode
}

const AccessControl = ({
  role,
  renderIfAdmin,
  renderIfUser,
}: AccessControlProps) => {
  return (
    <>
      {role === UserRole.ADMIN && renderIfAdmin}
      {role === UserRole.USER && renderIfUser}
    </>
  )
}

export default AccessControl
